import React from 'react';
import classnames from 'classnames';

const QuoteSteps = (props) => {
  const { activeItem } = props;

  // TODO: translate
  const list = [
    { id: 1, text: 'Get a quote' },
    { id: 2, text: 'Select quantity / Lead Time' },
    { id: 3, text: 'Upload Gerber file' },
    { id: 4, text: 'Add to cart' },
  ];

  return (
    <div className="row g-0 quote-steps">
      {list.map((item) => (
        <Step
          key={item.id}
          id={item.id}
          text={item.text}
          done={item.id < activeItem}
          active={item.id === activeItem} />
      ))}
    </div>
  );
};

const Step = (props) => {
  const {
    active,
    done,
    text,
    id,
  } = props;

  const className = classnames({
    'qs-item': true,
    col: true,
    active,
    prevactive: done,
  });

  return (
    <div className={className}>
      <span className="qs-number">{id}</span>
      <span className="qs-text">{text}</span>
      <span className="arrow" />
    </div>
  );
};

export default QuoteSteps;
